const identifierCollator = new Intl.Collator("en", { numeric: true });

/**
 * Natural order for text identifiers and product ids: digit runs compare by value, so "in1000-p1-q9"
 * comes before "in1000-p1-q10" and "in754" before "in1000" (plain localeCompare gets both wrong). Same collation as the PrimeVue
 * DataTable column sort, so exports and lists match the order of the editing grid.
 */
export function compareIdentifiers(a: string, b: string): number {
    return identifierCollator.compare(a, b);
}
